import React from 'react'
import ComingSoon from '../Common/ComingSoon'

const Accomodation = () => {
  return (
    <ComingSoon />
  )
}

export default Accomodation